
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// 根据域名确定默认语言
const getDefaultLanguage = () => {
  const hostname = window.location.hostname;
  
  // 如果域名是koluno.com，默认语言为英文
  if (hostname === 'koluno.com' || hostname === 'www.koluno.com') {
    return 'en';
  }
  
  // 其他情况默认为中文
  return 'zh';
};

// 自定义语言检测器，优先考虑域名设置
const customDetector = {
  name: 'customDetector',
  lookup() {
    const hostname = window.location.hostname;
    
    // 如果是koluno.com域名，强制使用英文
    if (hostname === 'koluno.com' || hostname === 'www.koluno.com') {
      return 'en';
    }
    
    // 其他域名检查localStorage中的设置
    const stored = localStorage.getItem('i18nextLng');
    if (stored) {
      return stored;
    }
    
    // 最后使用默认语言
    return getDefaultLanguage();
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  }
};

i18n
  .use({
    type: 'languageDetector',
    async: false,
    detect: customDetector.lookup,
    init() {},
    cacheUserLanguage: customDetector.cacheUserLanguage
  })
  .use(initReactI18next)
  .init({
    fallbackLng: getDefaultLanguage(),
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
